import { useAuth } from "@/hooks/auth";
import { useRoleFlags, RoleFlags } from "./useRoleFlags";

export const useRoles = (): { roles: string[] } & RoleFlags => {
  const { roles } = useAuth();
  const roleFlags = useRoleFlags(roles);
  return { roles, ...roleFlags };
};